import { nerdNetworkBaseQuery } from "@nerdjs/nerd-network";
import { createApi } from "@reduxjs/toolkit/query/react";
import { sanitizeNumericPayload } from "../../helpers/numberHelpers";

function sanitizeRequestArgs(args: unknown): unknown {
  if (!args || typeof args !== "object" || !("body" in args)) {
    return args;
  }

  return {
    ...args,
    body: sanitizeNumericPayload((args as { body: unknown }).body),
  };
}

export const filmsApi = createApi({
  reducerPath: "filmsApi",
  baseQuery: (args, api) =>
    nerdNetworkBaseQuery(sanitizeRequestArgs(args), api, { service: "films" }),
  endpoints: () => ({}),
  tagTypes: [
    "benefits",
    "budgets",
    "cues",
    "expenses",
    "jobs",
    "jobCategories",
    "jobTasks",
    "positions",
    "projects",
    "projectTasks",
    "projectTypes",
    "rates",
    "scales",
    "vendors",
    "talents",
    "tasks",
    "taskTypes",
    "vtransactions",
    "timers",
    "reconciliations",
  ],
});
